<template>
  <div class="report_builder">
    <v-container>
      <v-row>
        <h2 class="mb-2">
          {{ $store.state.customerName }}:帳票入力 作成画面 CreateReport.vue
        </h2>
        <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="false"
          cols="12"
          sm="3"
          style="max-height: 600px max-width: 600px"
          class="overflow-y-auto"
        >
          <h3 class="mb-2">Form Parts</h3>
          <draggable
            v-model="sampleForms"
            :group="{ name: 'forms', pull: 'clone', put: false }"
            :sort="false"
            :clone="cloneForm"
          >
            <!-- 各フォームパーツ--->
            <v-card
              max-height="400"
              class="mb-4"
              v-for="(form, i) in sampleForms"
              :key="i"
            >
              <v-card-title>{{ form.name }}</v-card-title>
              <v-card-text>{{ form.text }}</v-card-text>
            </v-card>
          </draggable>
        </v-col>
        <!--  Form Parts を消した場合は12に変更   -->
        <v-col cols="12">
          <v-card outlined class="pa-6" max-width="1200">
            <h3 class="mb-2">配置(左上詰め)</h3>
            <p>{{ message }}</p>
            <!-- マス目表示 -->
            <v-row rows="3">
              <v-col cols="12">
                <dragfiled
                  class="d-flex justify-content-end"
                  ref="dragfiled"
                  :area_temp="productForms.area"
                  :r="row"
                  :c="col"
                  v-on:clickSubmit="modalOpen"
                  v-on:clickSubmit2="dataChange"
                  v-on:clickDelete="removeForm"
                  v-on:clickTakeover="TakeOverForm"
                  v-on:formCopy="copyForm"
                  v-on:formCopyRow="copyFormRow"
                >
                </dragfiled>
              </v-col>
            </v-row>
          </v-card>
          <!-- モーダル表示 -->
          <div>
            <modal-list
              ref="formList"
              v-on:clickSubmit="modalClose"
              :formTypes="sampleForms"
            ></modal-list>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="col_add(1)" color="primary" class="ma-1">行追加</v-btn>
          <v-btn @click="row_add(1)" color="primary" class="ma-1">列追加</v-btn>
        </v-col>
        <v-col align="center" class="ma-1" cols="4">
          <v-btn @click.once="saveForm()" color="primary" x-large>SAVE</v-btn>
        </v-col>
        <v-col align="right" class="ma1">
          <v-btn @click="preview()" color="primary">プレビュー</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-file-input
            v-model="json"
            type="file"
            accept=".json"
            label="json取り込み"
            prepend-icon="mdi-image"
            ref="rfafile"
            @change="jsonImport"
          ></v-file-input>
        </v-col>
        <v-col cols="3">
          <v-btn class="ma-1" @click="jsonExport()">json出力</v-btn>
        </v-col>
        <v-col cols="1">
          <v-select
            :items="lineNums"
            v-model="addRowIndex"
            item-text="text"
            item-value="value"
            label="行数"
            :rules="[]"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-btn class="ma-1" @click="insertOneline(addRowIndex)"
            >{{ addRowIndex }}行目に1行挿入</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import dragfiled from "../../components/DragFiled/DragFiled";
import modalList from "../../components/BuilderForm/ReportCreate/ModalList";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");
const Encoding = require("encoding-japanese");

export default {
  components: {
    draggable,
    modalList,
    dragfiled,
  },
  data() {
    return {
      sampleForms: [
        {
          type: 1,
          name: "テキストエリア(1行)",
          label: "ラベル名",
          text: "テキストエリアが追加されます",
          cols: "0",
          init: "",
          size: 0, //テキストエリアとの併用のための値
          rule: ",0",
          value: ",",
        },
        {
          type: 2,
          name: "セレクトボックス",
          label: "ラベル名",
          text: "セレクトボックスが追加されます",
          cols: "0",
          //
          init: "",
          selectbox: ["a", "b", "c"],
          from_check: false,
          rule: "0", //検索対象のformID格納に使用
        },
        {
          type: 3,
          name: "日付欄",
          label: "年月日",
          text: "日付を扱うフォームです。入力欄横にカレンダーが追加されます。",
          rule: "",
          cols: "0",
        },
        /*
          type: 4,
          Menuで使用
        */
        /*
          type: 5,
          Indexで使用
        */
        /*
          type: 6,
          MainMenu(SideBar)で使用
        */
        {
          type: 7,
          name: "ラジオボタン(単一選択)",
          label: "ラジオボタン(単一)",
          text: "チェックボックスが追加されます。",
          cols: "0",
          init: "a",
          checkbox: ["a", "b", "c"],
        },
        {
          type: 14,
          name: "チェックボックス(複数選択)",
          label: "チェックボックス(複数)",
          text: "チェックボックスが追加されます。",
          cols: "auto",
          init: "a",
          checkbox: ["a", "b", "c"],
        },
        {
          type: 8,
          name: "テキストエリア(複数行)",
          label: "テキストエリア(複数)",
          text: "テキストエリアが追加されます。",
          cols: "0",
          init: "",
          size: 5,
          rule: ",0",
        },
        {
          type: 9,
          name: "ファイルアップロード欄",
          label: "デフォルト値",
          text: "画像のアップロードフォームが追加されます。",
          cols: "0",
          init: "init",
          file_type: "image",
        },
        {
          type: 10,
          name: "画像表示・ダウンロード欄",
          label: "画像表示欄",
          init: "0",
          text: "指定した画像が表示されます。",
          cols: "0",
          width: 100,
          height: 100,
        },
        {
          type: 11,
          name: "テキストエリア(プラスボタン付き)",
          label: "ラベル名",
          text: "プラスボタン付きのテキストエリアが追加されます。",
          cols: "0",
          init: "",
          size: 0, //テキストエリアとの併用のための値
          rule: ",0",
          value: "50,15",
        },
        /*
        {
          type: 12,
          name: "ムダミエールボタン",
          label: "作業時間",
          text: "開始ボタンと終了ボタンが追加され、作業時間を算出できます。",
          init: "初期値",
          rule: "0,0",
          //
        },
        */
        /*
          type: 13,
          CSVimportで使用
        */
        {
          type: 15,
          name: "時刻選択",
          label: "時刻",
          text: "時刻フォームが追加されます。",
          cols: "0",
          rule: "0,0",
        },
        {
          type: 16,
          name: "ボタンフォーム",
          label: "ボタン",
          text: "ボタンフォームが追加されます。",
          cols: "0",
          rule: "0,0,0,0,,0,",
          color: "success",
        },
        {
          type: 17,
          name: "サブページ",
          text: "サブフォームが追加されます。",
          cols: 0,
          label: "サブページ(1行独占)",
          value:
            '[{"formID":100,"label":"test1"},{"formID":100,"label":"test2"}]', //json形式
          rule: "30.1,list", //最大追加件数
          init: "0", //pageID
        },
        {
          type: 18,
          name: "ユーザ情報・パスワード",
          label: "ユーザ情報",
          text: "ユーザ情報を選択する",
          cols: "0",
          rule: "0,0",
          init: "default",
        },
        {
          type: 19,
          name: "帳票コピー機能",
          label: "コピー(左上固定)",
          text: "入力済み帳票から入力値をコピーし新規作成する",
          color: "red",
          value: "",
        },
        {
          type: 20,
          name: "送信ボタンオプション",
          label: "送信ボタンオプション",
          text: "送信ボタンに関連するオプションを設定",
          cols: 0,
          init: "",
          rule: "3,0,0,0,1,0,",
          color: "primary",
          value: "",
        },
        /*
        {
          //使用済み:承認権限に関わるフォーム
          type: 21,
        },
        */
        {
          type: 22,
          name: "削除ボタンオプション",
          label: "削除",
          text: "削除ボタンに関連するオプションを設定",
          cols: "0",
          init: "",
          color: "primary,white--text",
          value: null,
        },
        {
          type: 23,
          name: "自動番号フォーム",
          text: "新規作成時に自動的に番号が割り振られるフォーム",
          cols: "0",
          label: "自動番号",
          value: "",
        },
        {
          type: 24,
          name: "表示・非表示切り替えフォーム",
          text: "条件ごとにフォームの表示・非表示を切り替える。",
          cols: 0,
          label: "条件表示",
          value: "",
          rule: "",
        },
        {
          type: 25,
          name: "入力制限フォーム",
          text: "一部を除いた全ての要素を無効にする",
          cols: 0,
          label: "全て無効",
          value: "",
          rule: "",
        },
        {
          type: 26,
          name: "戻るボタンフォーム",
          text: "戻るボタンの非表示・ラベル修正",
          cols: 0,
          label: "戻る",
          value: "",
          rule: "",
        },
        {
          type: 27,
          name: "空スペース",
          text: "colsによるサイズ調整",
          label: "スペース",
          cols: 0,
        },
        //28~30 はメール送信に使用--------------------------------------------------
        {
          type: 30,
          name: "メール送信先",
          label: "送信先",
          text: "セレクトによる送信先の設定",
          cols: 0,
          //
          init: "",
          selectbox: ["a", "b", "c"],
          from_check: false,
          rule: "0", //検索対象のformID格納に使用
        },
        {
          type: 28,
          name: "メール件名",
          label: "件名",
          text: "メールの件名を指定",
          cols: 0,
          init: "",
          size: 0, //テキストエリアとの併用のための値
          rule: ",0",
          value: ",",
        },
        {
          type: 29,
          name: "メール本文",
          label: "メール本文",
          text: "テキストエリアが追加されます。",
          cols: 0,
          init: "",
          size: 5,
          rule: ",0",
        },
        {
          type: 31,
          name: "QR読み取りフォーム",
          text: "カメラからQRを読み取りテキストフィールドに表示する",
          label: "QR読み取り",
          cols: "0",
          rule: "",
        },
        {
          type: 32,
          name: "通常テキスト",
          text: "純粋にテキスト表示を行う",
          label: "通常テキスト(1行占有)",
          cols: "12",
        },
        {
          type: 33,
          name: "マスタデータ保存",
          text: "他ページの情報を保存",
          label: "~~ページ情報",
          cols: "0",
        },
        {
          type: 34,
          name: "バリデーション設定",
          text: "特定状態でバリデーションチェックを飛ばす",
          label: "バリデーション状態",
          cols: "0",
        },
        {
          type: 35,
          name: "(未実装)特殊条件メッセージフォーム",
          text: "条件を満たす場合のみ、特定のメッセージ表示する",
          label: "特殊メッセージ",
          cols: "0",
        },
        {
          type: 36,
          name: "入力切り替え選択",
          text: "マスタ登録ページで入力内容を切り替えるために使用",
          label: "入力切り替え",
          cols: "0",
        },
        {
          type: 37,
          name: "マスタ取得/格納フォーム",
          text: "別ページのレポートを取得しマスタ形式で格納する",
          label: "マスタデータ",
          cols: "0",
        },
        {
          type: 38,
          name: "タブタイトル設定",
          text: "タブ名を変更できるようにする",
          label: "タブ名",
          cols: "0",
        },
        {
          type: 39,
          name: "自動スクロール機能",
          text: "自動スクロールに関するフォーム",
          label: "自動スクロール",
          cols: "0",
        },
        {
          type: 40,
          name: "別タブを開く",
          text: "別タブを開くボタンを追加するフォーム",
          label: "別タブ",
          cols: "0",
        },
        {
          type: 41,
          name: "マスタ検索フォーム&登録",
          text: "マスタをモーダルで検索し格納するフォーム",
          label: "ラベル",
          cols: "0",
        },
        {
          type: 42,
          name: "CSVダウンロード",
          text: "indexPage用CSVダウンロードボタン",
          cols: "0",
        },
        //--------------------------------------------------
        {
          name: "",
        },
      ],
      productForms: {
        pageID: 0,
        area: [[], []],
        delete_area: [],
      },
      //表の初期サイズ
      formID: 0,
      row: 5, //横
      col: 3, //縦
      addRowIndex: 1,
      message: "",
      json: {},
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  computed: {
    lineNums: function() {
      let result = [];
      for (let i = 0; i < this.col; i++) {
        result.push(i + 1);
      }

      return result;
    },
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      this.$store.commit("setCustomerID", Number(this.$route.params.id));
      //ページ毎の処理
      const path = this.$route.path.split("/");

      //メール送信設定の場合のみ表示する
      if (path[path.length - 1] != "mail_send_builder") {
        this.sampleForms = this.sampleForms.filter(
          (n) => n.type != 28 && n.type != 29 && n.type != 30
        );
      } else {
        this.message =
          "送信対象はセレクトボックス,件名はテキストフォーム、本文はテキストエリア";
      }
      switch (path[path.length - 1]) {
        case "subreport_builder": //サブページ
          //画像アップロード欄を削除
          //this.sampleForms = this.sampleForms.filter(n => n.type !== 9 );
          break;
        case "user_report_builder": //ユーザ情報設定
          //サブページを削除
          this.sampleForms = this.sampleForms.filter((n) => n.type !== 17);
          this.message =
            "1行目ユーザ名,2行目メールアドレス,3行目管理者権限が表示される";
          break;
        case "second_auth_builder": //2段階認証設定ページ
          this.message = "2段階認証設定ページ";
          this.sampleForms = this.sampleForms.filter((n) => n.type == 18);
          break;
        case "master_sub": //マスタ登録形式サブページ
          this.sampleForms = this.sampleForms.filter(
            (n) =>
              n.type == 1 ||
              n.type == 11 ||
              n.type == 7 ||
              n.type == 3 ||
              n.type == 32 ||
              n.type == 36
          );
          break;
        default:
          //レポート作成ページ
          //this.sampleForms = this.sampleForms.filter((n) => n.type != 36);
          break;
      }

      //page IDとcustomer IDとform情報を送信
      let data = {};
      data.customerID = Number(this.$route.params.id);
      data.pageID = Number(this.$route.params.page_id);
      this.$store.state.customerID = Number(this.$route.params.id);
      this.productForms.pageID = this.$route.params.page_id;
      //API通信
      const response = await api.GetForm(data);
      //横列が3列以上の場合
      if (this.row < response.data.length) {
        for (let i = 0; i < response.data.length - this.row; i++) {
          this.productForms.area.push([]);
          this.row_add(response.data.length - this.row);
        }
        this.row = response.data.length;
      }
      //縦列が初期値以上の場合
      response.data.forEach((v) => {
        if (this.col < v.length) {
          this.col_add(v.length - this.col);
        }
      });
      //データを格納
      let tmp = [{ form_id: 0, label: "", type: 0 }];
      for (let i = 0; i < this.row; i++) {
        this.$set(
          this.productForms.area,
          [i],
          this.respose_convert(response.data[i])
        );
        //空配列の格納
        for (let j = this.productForms.area[i].length; j < this.col; j++) {
          this.productForms.area[i].push(Object.assign({}, tmp[0]));
        }
      }
      this.$nextTick(function() {
        //DOMがマウントされるまで待機してから実行
        //ドラッグフォームへ値を渡す(宣言時はapiからの戻り値を取得できないため)
        this.$refs.dragfiled.load(this.productForms.area);
        this.$refs.dragfiled.draw();
      });
      //読み込み終了
      this.isLoading = false;
    },
    async saveForm() {
      let data = {};
      data.area = this.productForms.area;
      //不要な情報の削除
      data.area.some(function(v) {
        delete v.name;
      });
      data.delete_area = this.productForms.delete_area;
      data.pageID = this.productForms.pageID;
      try {
        data.pageID = await api.RegForm(data, "");
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    modalOpen: function(form, i, j) {
      this.$refs.formList.open(form, i, j);
    },
    modalClose(param, i, j) {
      let oldFromID = this.productForms.area[i][j].type;
      if (param.type < -4) {
        //複数フォームの生成
        if (this.row + i < param.length) {
          alert("列が足りません", this.row, param.ObjLength);
          return;
        }
        param.forEach((p, index) => {
          /*
          if (
            this.productForms.area[i+ inde][j ].form_id != null &&
            this.productForms.area[i+ inde][j ].form_id != 0
          ) {
            alert(
              "既にフォームが存在します|",
              this.productForms.area[i][j + index].form_id
            );
            return;
          }
          */
          this.$set(this.productForms.area[i + index], [j], p);
        });
      } else if (param.type < 0) {
        let copy;
        switch (param.type) {
          case -1: //←左
            if (i == 0) {
              console.log("範囲外をコピーしています");
              return;
            }
            copy = JSON.parse(JSON.stringify(this.productForms.area[i - 1][j]));
            break;
          case -2: //→右
            if (i == this.productForms.area.length - 1) {
              console.log("範囲外をコピーしています");
              return;
            }
            copy = JSON.parse(JSON.stringify(this.productForms.area[i + 1][j]));
            break;
          case -3: //↑上
            if (j == 0) {
              console.log("範囲外をコピーしています");
              return;
            }
            copy = JSON.parse(JSON.stringify(this.productForms.area[i][j - 1]));
            break;
          case -4: //↓下
            if (j == this.productForms.area[0].length - 1) {
              console.log("範囲外をコピーしています");
              return;
            }
            copy = JSON.parse(JSON.stringify(this.productForms.area[i][j + 1]));
            break;
        }
        //コピーの実行
        copy.form_id = 0;
        this.$set(this.productForms.area[i], [j], copy);
      } else {
        //新規フォームの代入
        this.$set(this.productForms.area[i], [j], param);
        //変更時フォームを開く
        if (oldFromID != this.productForms.area[i][j].type) {
          this.modalOpen(this.productForms.area[i][j], i, j);
        }
      }
      this.$refs.dragfiled.load(this.productForms.area);
    },
    respose_convert: function(data) {
      let area = [];
      if (typeof data === "undefined") {
        return [{ form_id: 0, label: "", type: 0 }];
      }
      data.forEach((value) => {
        try {
          let tmp = {};
          tmp.form_id = value.ID;
          tmp.type = value.Type;
          tmp.name = value.Name;
          tmp.label = value.Label;
          tmp.cols = value.Cols;
          tmp.css = value.Css;
          switch (value.Type) {
            case 1: //テキストエリア
            case 17: //サブページ
            case 28: //メール件名
            case 33: //マスタデータ保存
            case 34: //バリデーション
            case 36: //入力切り替え
            case 37: //マスタデータ取得格納
            case 41: //マスタデータ検索格納
              tmp.value = value.Value;
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              break;
            case 15: //時刻
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              break;
            case 2: //セレクトボックス
            case 30: //送信先指定
              if (value.Value == "") {
                //空の場合
                tmp.selectbox = [""];
              } else if (value.Value != "") {
                let tmp1 = value.Value.replace(/"/g, "").split(",");
                let tmp2 = JSON.parse(value.Value);
                if (tmp1.filter((t) => t.match(/\n/g)) == []) {
                  //旧値
                  tmp.selectbox = tmp1;
                } else {
                  tmp.selectbox = tmp2;
                }
              } else {
                tmp.selectbox = JSON.parse(value.Value);
              }
              tmp.init = value.Init;
              if (value.Rule != "" && value.Rule != "0") {
                tmp.rule = value.Rule;
                tmp.form_check = true;
              }
              break;
            case 3: //カレンダー
              tmp.form_id = value.ID;
              tmp.value = value.Value;
              tmp.rule = value.Rule;
              break;
            case 7:
            case 14:
              //チェックボックス
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              var str2 = value.Value.replace(/"/g, "")
                .slice(1)
                .slice(0, -1);
              tmp.checkbox = str2.split(",");
              break;
            case 8: //テキストエリア
            case 29: //メール本文
              tmp.init = value.Init;
              tmp.size = Number(value.Value);
              tmp.rule = value.Rule;
              break;
            case 9:
              //アップロードフォーム
              tmp.init = value.Init;
              tmp.file_type = value.Rule;
              break;
            case 10:
              //画像
              tmp.init = value.Init;
              var str3 = value.Rule.split(",");
              tmp.height = Number(str3[0]);
              tmp.width = Number(str3[1]);
              break;
            case 11: //プラスボタン付きテキストエリア
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              tmp.value = value.Value;
              break;
            case 12: //ムダミエールボタン
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              break;
            case 16: //ボタン
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              tmp.color = value.Value;
              break;
            case 18: //認証情報
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              tmp.value = value.Value;
              break;
            case 19:
              tmp.color = value.Rule;
              tmp.value = value.Value;
              break;
            case 20: //送信ボタンオプション
              tmp.rule = value.Rule;
              tmp.color = value.Value;
              tmp.init = value.Init;
              break;
            case 22: //削除ボタンオプション
              if (value.Value != "") {
                tmp.value = JSON.parse(value.Value);
              }
              tmp.color = value.Rule;

              break;
            case 23: //自動採番フォーム
              tmp.value = value.Value;
              break;
            case 24: //divフォーム
              tmp.rule = value.Rule;
              //tmp.value = value.Value;
              break;
            case 25: //allDisabedフォーム
              tmp.rule = value.Rule;
              //tmp.value = value.Value;
              break;
            case 26: //戻るフォーム
              tmp.rule = value.Rule;
              //tmp.value = value.Value;
              break;
            case 27: //空枠フォーム
              //特に何かを保存しない
              break;
            case (28, 29, 30): //メールの件名と本文で使用
              break;
            case 31: //QR読み取りフォーム
              tmp.rule = value.Rule;
              break;
            case 32: //プレインテキスト
              tmp.value = value.Value;
              tmp.rule = value.Rule;
              break;
            //case 33.34使用済み
            case 38:
              tmp.init = value.Init;
              tmp.rule = value.Rule;
              break;
            case 39: //自動スクロール
              tmp.rule = value.Rule;
              break;
          }
          //
          area.push(tmp);
        } catch (e) {
          alert("respose_convertエラー");
          console.log(e);
        }
      });
      return area;
    },
    back() {
      this.$store.state.customerID == Number(this.$route.params.id);
      this.$router.push({
        path: "/customer/" + this.$store.state.customerID + "/report_builder",
      });
    },
    //DrugFiled関連-----------------------------------------------------
    dataChange(area) {
      this.productForms.area = area;
    },
    removeForm: function() {
      let del_form = this.productForms.area[this.productForms.area.length - 1][
        this.productForms.area[0].length - 1
      ];
      if (del_form.type != 0) {
        this.productForms.delete_area.push(del_form);
        this.productForms.area[this.productForms.area.length - 1][
          this.productForms.area[0].length - 1
        ] = { form_id: 0, label: "null", type: 0 };
      }
      this.$refs.dragfiled.load(this.productForms.area);
    },
    copyForm: function() {
      let fromForm = JSON.parse(
        JSON.stringify(
          this.productForms.area[0][this.productForms.area[0].length - 1]
        )
      );
      let toForm = this.productForms.area[this.productForms.area.length - 1][
        this.productForms.area[0].length - 1
      ];

      if (fromForm.type != 0 && toForm.type == 0) {
        fromForm.form_id = 0;
        this.$set(
          this.productForms.area[this.productForms.area.length - 1],
          [this.productForms.area[0].length - 1],
          Object.assign({}, fromForm)
        );
      } else {
        alert("コピー元が空 or コピー先にIDが存在");
      }
      //再読み込み
      this.$refs.dragfiled.load(this.productForms.area);
    },
    //最終一行コピー
    async copyFormRow() {
      await this.col_add(1);
      this.productForms.area.forEach((value, index) => {
        let from = JSON.parse(JSON.stringify(value[value.length - 2]));
        console.log(from, "|", index, value.length - 1);
        if (from.type != 0) {
          from.form_id = 0;
          this.$set(
            this.productForms.area[index],
            [value.length - 1],
            Object.assign({}, from)
          );
        }
      });
      //再読み込み
      this.$refs.dragfiled.load(this.productForms.area);
    },
    TakeOverForm() {
      //フォームタイプのリセット
      this.productForms.area[this.productForms.area.length - 1][
        this.productForms.area[0].length - 1
      ].type = 0;
      //再読み込み
      this.$refs.dragfiled.load(this.productForms.area);
      /*
      this.formID = this.productForms.area[this.productForms.area.length - 1][
        this.productForms.area[0].length - 1
      ].form_id;
      */
    },
    //n行目を追加
    insertOneline(index) {
      if (index > 0) {
        this.col++;
        this.$refs.dragfiled.insertOneline(index);
        this.$refs.dragfiled.load(this.productForms.area);
        //描画処理
        this.$nextTick(function() {
          this.$refs.dragfiled.draw();
        });
      }
    },
    col_add(n) {
      for (let i = 0; i < n; i++) {
        this.col++;
        this.$refs.dragfiled.col_add();
        this.$refs.dragfiled.load(this.productForms.area);
      }
      this.$nextTick(function() {
        //DOMがマウントされるまで待機してから実行
        this.$refs.dragfiled.draw();
      });
    },
    row_add(n) {
      for (let i = 0; i < n; i++) {
        this.row++;
        this.$refs.dragfiled.row_add();
        this.$refs.dragfiled.load(this.productForms.area);
      }
      this.$nextTick(function() {
        //DOMがマウントされるまで待機してから実行
        this.$refs.dragfiled.draw();
      });
    },
    //jsonインポート関連------------------------------------------------------
    async jsonImport(file) {
      try {
        //文字コード変換
        const data = await this.charCodeConvert(file);
        const json = JSON.parse(data);
        json.forEach((v) => {
          v.forEach((vv) => {
            vv.form_id = 0;
          });
        });
        //格納
        this.productForms.area = json;
        this.$refs.dragfiled.load(this.productForms.area);
      } catch (e) {
        console.log(e);
      }
    },
    jsonExport() {
      const json = JSON.stringify(this.productForms.area, null, 2);
      let blob = new Blob([json], { type: "text/json" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "seisei_front_" + this.productForms.pageID + ".json";
      link.click();
    },
    charCodeConvert(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          //文字列をバイト列に変換
          var sjisArray = new Uint8Array(reader.result);
          //encode.jsを使い、文字コードを自動判別しUNICODEへ変換
          var unicodeArray = Encoding.convert(sjisArray, {
            to: "UNICODE",
            from: "AUTO",
            type: "string",
          });
          resolve(unicodeArray);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },
    //プレビュー関連------------------------------------------------------
    preview() {
      let data = {};
      data.area = this.productForms.area;
      //不要な情報の削除
      //v.nameはいらない
      data.pageID = this.productForms.pageID;
      //ローカルストレージを使用して別タブでプレビュー画面を表示する
      localStorage.setItem("kakanai_preview", JSON.stringify(data));
      let NewTab = this.$router.resolve({
        name: "PreviewReportCreate",
        params: { data: data },
      });
      window.open(NewTab.href, "_blank");
    },
    //----------------------------------------------------------------
    openFormSelect() {
      let i = 0;
      let j = 0;
      console.log("openFormSelect:", i, j);
    },
  },
};
</script>

<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}
/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
